import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from '@auth';
import { User as FirebaseUser } from '@angular/fire/auth';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false,
})
export class LoginFormComponent implements OnInit {
  @Output() firebaseUser = new EventEmitter<FirebaseUser>();
  form!: FormGroup;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', []],
      wachtwoord: ['', []],
    });
  }

  localLogin() {
    this.errorMessage = '';
    this.authService
      .login(this.form.controls.email.value, this.form.controls.wachtwoord.value)
      .then((userCredentials) => {
        if (userCredentials.user) {
          this.firebaseUser.next(userCredentials.user);
        }
      })
      .catch((err) => {
        this.errorMessage = err.message || 'An error occurred during login.';
      });
  }

  loginWithGoogle() {
    this.errorMessage = '';
    this.authService
      .loginWithGoogle()
      .then((userCredentials) => {
        if (userCredentials?.user) {
          this.firebaseUser.next(userCredentials.user);
        }
      })
      .catch((err) => {
        this.errorMessage = err.message || 'An error occurred during Google login.';
      });
  }
}
